import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=46ccdc5b"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports